import React from "react";
import { useTranslation } from "react-i18next";
import { CiTrash } from "react-icons/ci";

import css from "./ButtonDelete.module.css";

const ButtonDelete = (props) => {
  const { onClick, isOnlyIcon } = props;
  const { t } = useTranslation();

  return (
    <button className={css.wrap} onClick={onClick}>
      {isOnlyIcon ? <></> : t("delete-text")}
      <span className={css.icon}>
        <CiTrash />
      </span>
    </button>
  );
};

export { ButtonDelete };
